import { DeleteCourseSubjectType } from "../../../types/CourseSubject";
import { del, patch } from "../../../utils/axios-config";
import { COURSES_SUBJECTS } from "../../../utils/constants";

export const deleteCourseSubject = async (data: DeleteCourseSubjectType) => await patch<DeleteCourseSubjectType, boolean>(COURSES_SUBJECTS, data);